import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


const ProviderDescriptionModal = (props) => {

    const {
        confirmModal,
        setConfirmModal,
        providerData,
        activeIndex
    } = props

    console.log("providerdata",providerData)

    const closeBtn = (
        <i className="fa fa-times cursor-pointer" aria-hidden="true"
        onClick={() => setConfirmModal(false)}></i>
    )

    return (
        <Modal isOpen={confirmModal} toggle={setConfirmModal} 
        backdrop={false} keyboard={false}
        className="alert-modal cl-video video-modal modal-lg desc-modal" centered>
            <ModalHeader toggle={setConfirmModal} close={closeBtn}>
               
               {providerData?.is_bundle ? 
               <>
               <div dangerouslySetInnerHTML={{
                    __html: providerData?.list[activeIndex]?.name
                }}>
                </div>
               </>
                :
                <div dangerouslySetInnerHTML={{
                    __html: providerData?.product_name
                }}>
                </div> 
                } 
               
            </ModalHeader>
            <ModalBody>
            {providerData?.is_bundle ?  <div dangerouslySetInnerHTML={{
                    __html: providerData?.list[activeIndex]?.long_description
                }}></div> :
                <div dangerouslySetInnerHTML={{
                    __html: providerData?.long_description
                }}></div>
            }
            </ModalBody>
        </Modal>
    )
}

export default ProviderDescriptionModal;